import { RootState } from 'store'
import { entityAdapter } from './reducer'

export const { selectAll: selectAllConnections } = entityAdapter.getSelectors(
  (state: RootState) => state.connections
)

export const selectConnectionsStatus = (state: RootState) => state.connections.status
